import { PageBreadcrumb } from "@/components/PageBreadcrumb";
import { SiteLayout } from "@/components/SiteLayout";
import { NewsletterSignup } from "@/components/newsletter/NewsletterSignup";
import { useSite } from "@/hooks/use-site";

export function NewsletterPage() {
  const { messages } = useSite();

  return (
    <SiteLayout>
      <PageBreadcrumb items={[{ label: messages.footerLinkNewsletter }]} />

      <section className="relative isolate overflow-hidden border-b border-border/60 bg-muted/20 px-6 py-12 sm:py-16 lg:py-20">
        <div
          aria-hidden
          className="pointer-events-none absolute inset-0 -z-20 bg-grid opacity-20"
        />
        <div
          aria-hidden
          className="pointer-events-none absolute left-1/2 top-0 -z-10 h-[24rem] w-[52rem] -translate-x-1/2 rounded-full bg-primary/10 blur-3xl"
        />

        <div className="mx-auto max-w-6xl">
          <NewsletterSignup source="newsletter-page" variant="page" />
        </div>
      </section>
    </SiteLayout>
  );
}
